export function toQueryParams(a: any) {
  let s: any[] = []
  const add = function (k: string, v: any) {
    v = typeof v === 'function' ? v() : v
    if (v) {
      s[s.length] = encodeURIComponent(k) + '=' + encodeURIComponent(v)
    }
  }

  const buildParams = function (prefix: string, obj: any) {
    let i, len, key

    if (prefix) {
      if (Array.isArray(obj)) {
        for (i = 0, len = obj.length; i < len; i++) {
          buildParams(
            prefix + '[' + (typeof obj[i] === 'object' && obj[i] ? i : '') + ']',
            obj[i]
          )
        }
      } else if (Object.prototype.toString.call(obj) === '[object Object]') {
        for (key in obj) {
          buildParams(prefix + '[' + key + ']', obj[key])
        }
      } else {
        add(prefix, obj)
      }
    } else if (Array.isArray(obj)) {
      for (i = 0, len = obj.length; i < len; i++) {
        add(obj[i].name, obj[i].value)
      }
    } else {
      for (key in obj) {
        buildParams(key, obj[key])
      }
    }
    return s
  }

  return buildParams('', a).join('&')
}


export function fromQueryParams(params: any) {
  let obj = {} as any

  if (!params) return obj

  // Iterate over all name=value pairs.
  params.replace(/\+/g, ' ').split('&').forEach(function (v: string) {
    let param = v.split('='),
      key = decodeURIComponent(param[0]),
      val,
      cur = obj,
      i = 0,

      // If key is more complex than 'foo', like 'a[]' or 'a[b][c]', split it
      // into its component parts.
      keys = key.split(']['),
      keys_last = keys.length - 1

    // If the first keys part contains [ and the last ends with ], then []
    // are correctly balanced.
    if (/\[/.test(keys[0]) && /\]$/.test(keys[keys_last])) {
      // Remove the trailing ] from the last keys part.
      keys[keys_last] = keys[keys_last].replace(/\]$/, '')

      // Split first keys part into two parts on the [ and add them back onto
      // the beginning of the keys array.
      keys = keys.shift()!.split('[').concat(keys)

      keys_last = keys.length - 1
    } else {
      // Basic 'foo' style key.
      keys_last = 0
    }

    // Are we dealing with a name=value pair, or just a name?
    if (param.length === 2) {
      val = decodeURIComponent(param[1])

      if (keys_last) {
        // Complex key, build deep object structure based on a few rules:
        // * The 'cur' pointer starts at the object top-level.
        // * [] = array push (n is set to array length), [n] = array if n is
        //   numeric, otherwise object.
        // * If at the last keys part, set the value.
        // * For each keys part, if the current level is undefined create an
        //   object or array based on the type of the next keys part.
        // * Move the 'cur' pointer to the next level.
        // * Rinse & repeat.
        for (; i <= keys_last; i++) {
          key = keys[i] === '' ? cur.length : keys[i]
          cur = cur[key] = i < keys_last
            ? cur[key] || (keys[i + 1] && isNaN((keys as any)[i + 1]!) ? {} : [])
            : val
        }

      } else {
        // Simple key, even simpler rules, since only scalars and shallow
        // arrays are allowed.

        if (Object.prototype.toString.call(obj[key]) === '[object Array]') {
          // val is already an array, so push on the next value.
          obj[key].push(val)

        } else if ({}.hasOwnProperty.call(obj, key)) {
          // val isn't an array, but since a second value has been specified,
          // convert val into an array.
          obj[key] = [obj[key], val]

        } else {
          // val is a scalar.
          obj[key] = val
        }
      }
    } else if (key) {
      // No value was defined, so set something meaningful.
      obj[key] = ''
    }
  })

  return obj
}